import { render, staticRenderFns } from "./MissedCheckups.vue?vue&type=template&id=ad6be7c2&scoped=true&"
import script from "./MissedCheckups.vue?vue&type=script&lang=js&"
export * from "./MissedCheckups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6be7c2",
  null
  
)

export default component.exports